import { useEffect } from "react";
import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Placeholder from "@tiptap/extension-placeholder";

const ToolbarButton = ({ active, onClick, children, disabled }) => (
  <button
    type="button"
    className={`tiptap-button ${active ? "is-active" : ""}`}
    onClick={onClick}
    disabled={disabled}
  >
    {children}
  </button>
);

const TipTapEditor = ({ value, onChange, placeholder = "Escreva a bio da empresa..." }) => {
  const editor = useEditor({
    extensions: [StarterKit, Placeholder.configure({ placeholder })],
    content: value || "",
    editorProps: {
      attributes: {
        class: "tiptap-editor",
      },
    },
    onUpdate: ({ editor: instance }) => {
      const html = instance.getHTML();
      if (onChange) {
        onChange(html === "<p></p>" ? "" : html);
      }
    },
  });

  useEffect(() => {
    if (!editor) return;
    const current = editor.getHTML();
    const next = value || "";
    if (current !== next) {
      editor.commands.setContent(next || "", false);
    }
  }, [editor, value]);

  if (!editor) {
    return <div className="tiptap-shell is-loading">Carregando editor...</div>;
  }

  return (
    <div className="tiptap-shell">
      <div className="tiptap-toolbar">
        <ToolbarButton
          active={editor.isActive("bold")}
          onClick={() => editor.chain().focus().toggleBold().run()}
        >
          Negrito
        </ToolbarButton>
        <ToolbarButton
          active={editor.isActive("italic")}
          onClick={() => editor.chain().focus().toggleItalic().run()}
        >
          Itálico
        </ToolbarButton>
        <ToolbarButton
          active={editor.isActive("strike")}
          onClick={() => editor.chain().focus().toggleStrike().run()}
        >
          Risco
        </ToolbarButton>
        <ToolbarButton
          active={editor.isActive("bulletList")}
          onClick={() => editor.chain().focus().toggleBulletList().run()}
        >
          Lista
        </ToolbarButton>
        <ToolbarButton
          active={editor.isActive("orderedList")}
          onClick={() => editor.chain().focus().toggleOrderedList().run()}
        >
          Numerada
        </ToolbarButton>
        <ToolbarButton
          active={editor.isActive("blockquote")}
          onClick={() => editor.chain().focus().toggleBlockquote().run()}
        >
          Citação
        </ToolbarButton>
        <ToolbarButton onClick={() => editor.chain().focus().undo().run()} disabled={!editor.can().undo()}>
          Desfazer
        </ToolbarButton>
        <ToolbarButton onClick={() => editor.chain().focus().redo().run()} disabled={!editor.can().redo()}>
          Refazer
        </ToolbarButton>
      </div>
      <EditorContent editor={editor} />
      <div className="tiptap-help">Use o editor para destacar pontos fortes da empresa.</div>
    </div>
  );
};

export default TipTapEditor;
